import React from "react";
import { MainWrapper, Heading } from "./style";
import {
  Container,
  FlexWrapper,
  GradiantButton1,
  Text6,
} from "../../Common/index";
const TempeleteOne = ({
  backgroundUrl,
  heading1,
  heading2,
  description,
  ButtonTitle,
  onButtonClick,
  description2,
  styles
}) => {
  return (
    <MainWrapper backgroundUrl={backgroundUrl}>
      <Container margin={"40px auto"} style={{ ...styles }}>
        <FlexWrapper direction={"column"} justify={"center"} align={"center"}>
          {heading1 && (
            <Heading weight={900} fontFamily={"Inter"}>
              {heading1}
            </Heading>
          )}
          {heading2 && (
            <Heading weight={900} fontFamily={"Inter"}>
              {heading2}
            </Heading>
          )}
          {description && <Text6 color={"white"} weight={700}>{description}</Text6>}
          {description2 && <Text6 color={"white"} margin={"0px auto"} weight={700}>{description2}</Text6>}
          {ButtonTitle && (
            <GradiantButton1
              width={"400px"}
              height={"60px"}
              fontSize={"1.5rem"}
              color={"white"}
              margin={"50px auto 10px auto"}
            >
              {ButtonTitle}
            </GradiantButton1>
          )}
        </FlexWrapper>
      </Container>
    </MainWrapper>
  );
};

export default TempeleteOne;
